export const TOGGLE_CUSTOMER_TYPE = 'TOGGLE_CUSTOMER_TYPE';

// ACTION CREATORS
export const toggleCustomerType = data => ({ type: TOGGLE_CUSTOMER_TYPE, data });
